import React, { useEffect, useState } from 'react';

import classnames from 'classnames';
import Header from '../Header';
import Nav from '../Nav';
import Footer from '../Footer';
import qDocPromise from '../../js/qDoc';
import TeamRanking from './TeamRanking';
import TeamDetails from './TeamDetails';
import QdtComponent from '../QdtComponent';

const styles = require('./Teams-styles.css');

const Teams = () => {
  const [qDoc, setQDoc] = useState(null);
  const [qObj, setQObj] = useState(null);
  const [data, setData] = useState(null);
  const [activeTeam, setActiveTeam] = useState(null);
  const [playerTablePromise, setPlayerTablePromise] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const _qDoc = await qDocPromise;
        setQDoc(_qDoc);
        const _qObj = await _qDoc.createSessionObject({
          qInfo: { qType: 'data' },
          qTreeDataDef: {
            qDimensions: [
              {
                qDef: {
                  qFieldDefs: ["=If(c_Team <> '*unknown*', c_Team)"],
                  qFieldLabels: ['Team'],
                  qSortCriterias: [{ qSortByAscii: 1 }],
                },
                qNullSuppression: true,
                qAttributeDimensions: [
                  {
                    qDef: 'c_TeamShort',
                    qAttribute: true,
                  },
                ],
                qValueExprs: [
                  {
                    qDef: {
                      qDef: "=(sum(num#(c_Result1, '#####')) + sum(num#(c_Result2, '#####')))",
                      qLabel: 'Points',
                    },
                    qSortBy: { qSortByNumeric: -1 },
                  },
                  {
                    qDef: {
                      qDef: 'count({<TryFlag={1}>} n_MatchActionID)',
                      qLabel: 'Tries',
                    },
                    qSortBy: { qSortByNumeric: -1 },
                  },
                  {
                    qDef: {
                      qDef: 'count({<ConversionFlag={1}>} n_MatchActionID)',
                      qLabel: 'Conversions',
                    },
                    qSortBy: { qSortByNumeric: -1 },
                  },
                  {
                    qDef: {
                      qDef: 'count({<PenaltyFlag={1}>} n_MatchActionID)',
                      qLabel: 'Penalties',
                    },
                    qSortBy: { qSortByNumeric: -1 },
                  },
                  {
                    qDef: {
                      qDef: 'count({<DropGoalFlag={1}>} n_MatchActionID)',
                      qLabel: 'Drop Goals',
                    },
                    qSortBy: { qSortByNumeric: -1 },
                  },
                  {
                    qDef: {
                      qDef: "Count({<c_Gender={'Men'}>} DISTINCT n_MatchID)",
                      qLabel: 'Games',
                    },
                    qSortBy: { qSortByNumeric: -1 },
                  },
                  {
                    qDef: {
                      qDef: "Count({<c_Gender={'Men'}>} Aggr(If(c_Team = MatchWinner, 1), n_MatchID, c_Team))",
                      qLabel: 'Wins',
                    },
                    qSortBy: { qSortByNumeric: -1 },
                  },
                  {
                    qDef: {
                      qDef: "Count({<c_Gender={'Men'}>} Aggr(If(c_Team <> MatchWinner, 1), n_MatchID, c_Team))",
                      qLabel: 'Losses',
                    },
                    qSortBy: { qSortByNumeric: -1 },
                  },
                  {
                    qDef: {
                      qDef: "Count({<c_Gender={'Men'}>} Aggr(1, n_MatchID, c_Team)) - Count({<c_Gender={'Men'}>} Aggr(If(c_Team = MatchWinner, 1), n_MatchID, c_Team)) - Count({<c_Gender={'Men'}>} Aggr(If(c_Team <> MatchWinner, 1), n_MatchID, c_Team))",
                      qLabel: 'Ties',
                    },
                    qSortBy: { qSortByNumeric: -1 },
                  },
                  {
                    qDef: {
                      qDef: "Sum({<c_Gender={'Men'}>} n_DurationMinutes)",
                      qLabel: 'Minutes',
                    },
                    qSortBy: { qSortByNumeric: -1 },
                  },
                ],
              },
              {
                qDef: {
                  qFieldDefs: ['c_Edition'],
                },
                qAttributeDimensions: [
                  {
                    qDef: 'TeamFinalPlacement',
                    qAttribute: true,
                  },
                ],
              },
            ],
            qOpenFullyExpanded: true,
          },
        });
        setQObj(_qObj);
        _qObj.on('changed', async () => {
          setData(await _qObj.getHyperCubeTreeData('/qTreeDataDef'));
        });
        setData(await _qObj.getHyperCubeTreeData('/qTreeDataDef'));
      } catch (error) {
        console.log(error) //eslint-disable-line
      }
    })();
  }, []);
  useEffect(() => () => {
    if (qObj) qDoc.destroySessionObject(qObj.id);
  }, [qObj]);
  return (
    <>
      <Header />
      <Nav />
      <TeamRanking data={data} activeTeam={activeTeam} setActiveTeam={setActiveTeam} playerTablePromise={playerTablePromise} />
      {activeTeam && <TeamDetails data={data} activeTeam={activeTeam} />}
      <div className={styles.bottomTable}>
        <div className={classnames(styles.chart, !activeTeam && styles.hidden)}>
          <div className={styles.chartTitle}>PLAYER STATS</div>
          <QdtComponent
            type="QdtViz"
            props={{
              type: 'table',
              cols: [
                { qDef: { qFieldLabels: ['Player'], qFieldDefs: ['=c_Person'] }, qNullSuppression: true },
                // { qDef: { qFieldLabels: ['Country'], qFieldDefs: ['c_PersonNatioShort'] } },
                { qDef: { qFieldLabels: ['Height (cm)'], qFieldDefs: ['=n_Height/10'] } },
                { qDef: { qFieldLabels: ['Weight (kg)'], qFieldDefs: ['=n_Weight/1000'] } },
                { qDef: { qLabel: 'Games Played', qDef: "=Count({<c_Gender={'Men'}, n_MatchStatusCode={*} - {'0', '1', '2', '4'}>} DISTINCT n_MatchID)" } },
                { qDef: { qLabel: 'Starting Line Up', qDef: "=Count({<c_Gender={'Men'}, c_Action={'Starting line-up'}, n_MatchStatusCode={*} - {'0', '1', '2', '4'}>} DISTINCT n_MatchID)" } },
                { qDef: { qLabel: 'Points Scored', qDef: "=(sum(num#(c_Result1, '#####')) + sum(num#(c_Result2, '#####')))" } },
                { qDef: { qLabel: 'Tries', qDef: 'Sum(TryFlag)' } },
                { qDef: { qLabel: 'Assist Try', qDef: "Count({<c_Action={'Assist try'}>}c_Action)" } },
                { qDef: { qLabel: 'Conversions', qDef: 'sum(ConversionFlag)' } },
                { qDef: { qLabel: 'Penalties', qDef: 'sum(PenaltyFlag)' } },
                { qDef: { qLabel: 'Drop Goals', qDef: 'sum(DropGoalFlag)' } },
                { qDef: { qLabel: 'Yellow Cards', qDef: "Count({<c_Action={'Yellow Card'}>}c_Action)" } },
                { qDef: { qLabel: 'Red Cards', qDef: "Count({<c_Action={'Red Card'}>}c_Action)" } },
              ],
              height: '400px',
              options: { showTitles: false },
              noSelections: true,
            }}
            setComponentPromise={setPlayerTablePromise}
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Teams;
